export default "__VITE_ASSET__DdPlAseD__ 400w, __VITE_ASSET__1fUgZjbR__ 800w, __VITE_ASSET__D613BXAC__ 1024w";